/*
 * EIN KNOPF ZUM EIN- UND AUSKLAPPEN einer Spalte — nach dem Vorbild der Berater-Spalte rechts
 * (GuideBeraterSidebar: senkrechter Knopf „‹ Berater" oben an der Kante). Rafael, 03.10.2026 11:37:
 * „Ein Klick fährt den Guide nach links hinaus, ein zweiter fährt ihn wieder herein ... Dasselbe
 * gilt für den Coach." Zustand ist Geraete-Zustand (useUiPreferences/localStorage), nichts am Server.
 */
/*
 * ECHTE SYMBOLE STATT SCHRIFTZEICHEN (Rafael, 03.10.2026 16:05: die senkrechte Leiste
 * „sieht seltsam aus"). „‹"/„›" lagen in senkrechter Schrift quer, und „▭" fehlt in
 * manchen Schriften ganz (Kaestchen). Ein SVG steht in `writing-mode: vertical-rl`
 * aufrecht, ist von keiner Schrift abhaengig und folgt mit `currentColor` Hell/Dunkel.
 */
export type LeistenSymbolArt = 'links' | 'rechts' | 'reiter' | 'nebeneinander';
export function LeistenSymbol({ art }: { art: LeistenSymbolArt }) {
  const pfad = art === 'links' ? <path d="M9.5 3.5 5 8l4.5 4.5" />
    : art === 'rechts' ? <path d="M6.5 3.5 11 8l-4.5 4.5" />
    : art === 'reiter' ? <><path d="M2 5.5h12v8H2z" /><path d="M2 5.5V3h5v2.5" /></>
    : <><path d="M2 3h12v10H2z" /><path d="M8 3v10" /></>;
  return <svg className="cui-leisten-symbol" viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"
    fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{pfad}</svg>;
}
const ALS_SYMBOL: Record<string, LeistenSymbolArt> = { '‹': 'links', '›': 'rechts' };

export default function KlappKnopf({ aiId, controls, offen, senkrecht, text, pfeilOffen, pfeilZu, onClick }: {
  aiId: string; controls: string; offen: boolean; senkrecht?: boolean;
  text: string; pfeilOffen: string; pfeilZu: string; onClick: () => void;
}) {
  const titel = offen ? `${text} einklappen` : `${text} öffnen`;
  return <button type="button" className={`cui-klapp-knopf${senkrecht ? ' senkrecht' : ''}`} data-ai-id={aiId}
    aria-expanded={offen} aria-controls={controls} aria-label={titel} title={titel} onClick={onClick}>
    {(() => { const p = offen ? pfeilOffen : pfeilZu; return ALS_SYMBOL[p] ? <LeistenSymbol art={ALS_SYMBOL[p]} /> : <>{p}</>; })()}<span>{text}</span>
  </button>;
}
